import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

// Generic wrapper for class components to inject v6 router props
export default function withRouterV6(WrappedComponent) {
  return (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return <WrappedComponent {...props} navigate={navigate} location={location} params={params} />;
  };
}
